import { oneOf, shape } from 'prop-types'

import { ColdChainApiConnectionExecutionResultEnum } from '../../models/cold-chain/cold-chain-api-connection-execution-result-enum'
import { iso8601DurationPropType } from '../common/iso-8601-duration-prop-type'
import { iso8601PropType } from '../common/iso-8601-prop-type'

/**
 * @typedef {Object} ApiConnectionStatus
 * @property {ISO8601Duration} duration
 * @property {string} result
 * @property {ISO8601} startTime
 */
export const coldChainApiConnectionStatusPropType = shape({
    duration: iso8601DurationPropType,
    result: oneOf(Object.values(ColdChainApiConnectionExecutionResultEnum)).isRequired,
    startTime: iso8601PropType.isRequired
})
